import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 12v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-6m5 5c2.356 1.34 3.648 1.326 6 0M7.231 2h9.538c1.817 0 3.452 1.245 4.127 3.143l.758 2.132c.229.645.387 1.336.22 2C21.478 10.848 20.192 12 18.667 12c-1.841 0-3.334-1.679-3.334-3.75 0 2.071-1.492 3.75-3.333 3.75-1.84 0-3.333-1.679-3.333-3.75 0 2.071-1.493 3.75-3.333 3.75-1.526 0-2.811-1.152-3.208-2.725-.167-.664-.009-1.355.22-2l.759-2.132C3.78 3.245 5.415 2 7.23 2"
    />
  </svg>
);
export const IconStore = withDynamicStroke(Icon);
